"use strict";

import Bootstrap from './Bootstrap';
import Utils from './Helpers/Utils';

export default (linkId) => {
	if (!linkId) {
		linkId = sessionStorage.getItem("sparxpres-link-id");
		if (!linkId) {
			throw new Error("Please specify a valid linkId");
		}
	} else {
		sessionStorage.setItem("sparxpres-link-id", linkId);
	}

	// check if WebSale is running
	if (window.sparxpresWebSaleRunning) {
		//Utils.info("XpresWebSale is already loaded, dispatch event and exit....");
		//window.dispatchEvent(new Event("sparxpresRender"));
		Utils.info("XpresWebSale is already loaded, exiting....");
		return;
	}

	// set global variable on window that WebSale is running
	window.sparxpresWebSaleRunning = true;

	if (document.readyState === 'loading') {  // Loading hasn't finished yet
		Utils.info("Waiting for DOM to fully load...");
		document.addEventListener('DOMContentLoaded', (event) => {
			Utils.info('DOM fully loaded and parsed, starting XpresWebSale with linkId: %s', linkId);
			new Bootstrap(linkId);
		});
	} else {  // DOMContentLoaded has already fired
		Utils.info('DOMContentLoaded has already fired, starting XpresWebSale with linkId: %s', linkId);
		new Bootstrap(linkId);
	}

}
